import createBrowserHistory from 'history/lib/createBrowserHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createBrowserHistory);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-router/es/browserHistory.js
// module id = rMjN
// module chunks = 1